// extracted by mini-css-extract-plugin
export default {"link":"NotFound_link__k4nv4","error_container":"NotFound_error_container__Wr1Hi"};